<template>
  <div class="row custom-breadcrumb main-theme mb-5 pl-3">
    <div class="d-inline-flex">
      <div>
        <router-link :to="{ name: 'Landing' }"> {{ $t("title.home") }} </router-link>
      </div>
      <div class="mx-2">></div>
    </div>
    <div class="d-inline-flex">
      <div>
        <router-link :to="{ name: 'Initiatives' }">
          {{ $t("title.init") }}
        </router-link>
      </div>
      <div class="mx-2">></div>
    </div>
    <div class="d-inline-flex" v-if="holiday">
      <div>{{ $t("title.holiday") }}</div>
    </div>
    <div class="d-inline-flex" v-if="gv">
      <div>{{ $t("title.gv") }}</div>
      <div class="mx-2">></div>
    </div>
    <div class="d-inline-flex" v-if="gearing">
      <div>{{ $t("title.gearing") }}</div>
      <div class="mx-2">></div>
    </div>
    <div class="d-inline-flex">
      <div>{{ lastTag }}</div>
    </div>
  </div>
</template>

<script>
export default {
  name: "CustomBreadcrumb",
  props: {
    lastTag: String,
    holiday: Boolean,
    gv: Boolean,
    gearing: Boolean,
  },
};
</script>

<style></style>
